import React from 'react';

export const Login = React.lazy(() => import('./Login'));
export const SignUp = React.lazy(() => import('./SignUp'));
export const FindAccount = React.lazy(() => import('./Find'));
export const Profile = React.lazy(() => import('./Profile'));